import React, { useState, useEffect, useRef, use } from 'react';
import moment from 'moment';
import { RegExp } from '../../../library/constants/RegExp';
import ParentsUtil from '../../../library/util/ParentsUtil';
import { ApplyChannel, MembershipName } from '../../../library/constants/Code';
import { connect } from 'react-redux';
import DesktopLayerPopup from '../../common/DesktopLayerPopup';
import { CommonUtil } from '../../common/CommonUtil';
import WinkFreeStudyShippingAddress from './components/WinkFreeStudyShippingAddress';
import WinkFreeStudyChildSelect from './components/WinkFreeStudyChildSelect';
import * as MyPageMyInfoAction from '../../mypage/mypagemain/MyPageMyInfoAction';
import * as MemberAction from '../../member/MemberAction';
import UserServices from '../../../library/services/UserServices';
import { EmailDuplicationText } from '../../../library/constants/Constants';
import { TrialApplyDescription } from '../../trial-apply/components/TrialApplyDescription';
import { values, api, service } from './config';
import { fetch } from '../../../redux/actions';
import { routes } from '../../../constants/routes';
import { useAgreement } from '../../trial-apply/hooks/useAgreement';
import AgreementSection from './components/AgreementSection';
import LevelSelection from './components/LevelSelection';
import { AddtionalStudent } from './components/AddtionalStudent';
import { useMemberJoin, useTrial, useSpinner } from '@/hooks';
import {
    getTemporaryInformationOptionalAgreementParams,
    TERMS_AGREEMENT_CONTEXT,
    withTermsAgreementContext,
} from '@/library/util/TermsAgreementUtil';

const mapStateToProps = ({ MyPageMyInfoReducer, MemberReducer }) => {
    const { auth, actor, studentList, family } = MemberReducer;
    return {
        isModifyAuthData: MyPageMyInfoReducer.action === 'changeAuth',
        isEmailDuplicate: MyPageMyInfoReducer.action === 'emailDuplicate',
        actor,
        auth,
        studentList,
        family,
    };
};

const mapDispatchToProps = (dispatch) => ({
    modifyClearAction: () => dispatch(MyPageMyInfoAction.clearAction()),
    modifyAuths: (authData) => dispatch(MyPageMyInfoAction.modifyAuths(authData)),
    getMemberList: (familyId, studentId) => dispatch(MemberAction.getStudentList(familyId, studentId)),
    silentUpdateMultipleList: (list) => dispatch(fetch.silentUpdateMultipleList(list)),
});

const getInitialState = (auth) => {
    const [email1, email2] = auth?.human_email?.split('@') ?? ['', ''];
    return {
        email1,
        email2,
        oneMoreNames: [],
    };
};
const WinkFreeStudy = ({
    auth,
    studentList,
    family,
    getMemberList,
    silentUpdateMultipleList,
    modifyClearAction,
    modifyAuths,
    isEmailDuplicate,
    history,
}) => {
    const {
        experienceCount,
        userInfo,
        setUserInfo,
        selectedStudentInfoList,
        setSelectedStudentInfoList,
        completedAction,
        getExperienceCount,
        applySimple,
        applyStudy,
    } = useTrial();
    const { todayStudyMap, getTodayStudyMap } = useMemberJoin();
    const { setSpin } = useSpinner();
    const studentSeqRef = useRef(0);
    const levelChoicesRef = useRef([]);

    const {
        agreement: termsAgreement,
        onCheckBox: onAgreementCheckBox,
        validateAndShowAgreementPopup,
    } = useAgreement();

    const [hasExperiencePreConsultWork, setHasExperiencePreConsultWork] = useState(true);
    const [isChangeUserInfo, setIsChangeUserInfo] = useState(false);
    const [state, setState] = useState(() => getInitialState(auth));

    const { oneMoreNames } = state;

    useEffect(() => {
        init();
    }, []);

    const init = async () => {
        getTodayStudyMap();

        if (studentList.length !== 0) {
            getExperienceCount();
            getMemberList(family.id);
        }

        setUserInfo({
            human_name: auth.human_name,
            human_mdn: auth.human_mdn,
            human_address: auth.human_address,
            human_detail_address: auth.human_detail_address,
            human_email: auth.human_email,
            human_postal_code: auth.human_postal_code,
        });

        const { data } = await UserServices.getSettingInfo(
            'ApplyingServiceParamSetting',
            'ApplyingServiceParamSetting'
        );
        setHasExperiencePreConsultWork(data?.data?.has_experience_pre_consult_work ?? true);

        const currentLevel = service.getCurrentLevels();
        setSelectedStudentInfoList([
            {
                key: studentSeqRef.current,
                checkList: currentLevel,
            },
        ]);
    };

    useEffect(() => {
        if (auth.id) {
            setState(getInitialState(auth));
            setUserInfo({
                human_name: auth.human_name,
                human_mdn: auth.human_mdn,
                human_address: auth.human_address,
                human_detail_address: auth.human_detail_address,
                human_email: auth.human_email,
                human_postal_code: auth.human_postal_code,
            });
        }
    }, [auth.id]);

    useEffect(() => {
        setIsChangeUserInfo(false);
    }, [JSON.stringify(userInfo)]);

    useEffect(() => {
        if (isEmailDuplicate === true) {
            modifyClearAction();
            DesktopLayerPopup.notice({
                message: EmailDuplicationText,
                callback: () => {
                    setSpin(false);
                },
            });
        }
    }, [isEmailDuplicate]);

    const checkChildSubject = (index, studentInfo) => {
        checkChildSubjectWithName(index, studentInfo, state.oneMoreNames);
    };

    const checkChildSubjectWithName = (index, studentInfo, oneMoreNamesArg) => {
        const studentList = getAvailableApplyStudents(oneMoreNamesArg);
        setSelectedStudentInfoList(
            selectedStudentInfoList.map((item) => {
                if (item.key === studentInfo.key) {
                    return {
                        ...item,
                        childIndex: index,
                        ...studentList[index],
                    };
                }
                return item;
            })
        );
    };

    const getAuthTermAgreement = () => {
        const authData = { ...(auth?.data ?? {}) };
        return { ...authData.terms_agreement };
    };

    const isFieldsValid = () => {
        const { human_name, human_address, human_detail_address, human_postal_code, human_email } = userInfo ?? {};

        if (!human_name || !human_name.trim()) {
            DesktopLayerPopup.notice({
                message: '이름을 입력해 주세요',
            });
            return false;
        } else if (!human_address || !human_postal_code || !human_address.trim() || !human_postal_code.trim()) {
            DesktopLayerPopup.notice({
                message: '우편번호 찾기를 통해<br/> 주소를 입력해 주세요.',
            });
            return false;
        } else if (!human_detail_address || !human_detail_address.trim()) {
            DesktopLayerPopup.notice({ message: '상세주소를 입력해 주세요.' });
            return false;
        } else if (human_email && human_email.trim() && !RegExp.EMAIL.test(human_email)) {
            DesktopLayerPopup.notice({
                message: '올바른 이메일 형식을 입력해 주세요',
            });
            return false;
        } else if (!selectedStudentInfoList || !selectedStudentInfoList[0]?.id) {
            DesktopLayerPopup.notice({ message: '아이를 선택해 주세요' });
            return false;
        }
        return true;
    };

    const applyFreeStudy = async (termsAgreementOverride = termsAgreement) => {
        try {
            setSpin(true);
            const { oneMoreNames } = state;
            const { human_name, human_mdn, human_address, human_detail_address, human_postal_code, human_email } =
                userInfo;

            const isEndedStudentAndFirst =
                ParentsUtil.getMembership(selectedStudentInfoList[0]) === MembershipName.종료회원;
            const isOneMoreNameAndFirst = oneMoreNames.includes(selectedStudentInfoList[0]?.auth_human_name);
            const isOneMoreRequestAndFirst = isEndedStudentAndFirst || isOneMoreNameAndFirst;

            const birthday = selectedStudentInfoList?.[0]?.sdata?.auth_detail?.birthday ?? '';
            const trialStartAge = CommonUtil.getFreeApplyStartAge();
            const isUnderAgeAndFirst = !moment(birthday).isSameOrBefore(trialStartAge);

            const filteredStudentInfoList = selectedStudentInfoList?.filter(({ id }) => !!id) ?? [];

            if (filteredStudentInfoList.length > 1 || isOneMoreRequestAndFirst || isUnderAgeAndFirst) {
                const paramsToApply = filteredStudentInfoList.map((studentInfo, idx) => {
                    const isEndedStudent = ParentsUtil.getMembership(studentInfo) === MembershipName.종료회원;
                    const isOneMoreName = oneMoreNames.includes(studentInfo.auth_human_name);
                    const isOneMoreRequest = isEndedStudent || isOneMoreName;

                    let requestChannel = isOneMoreRequest ? `${ApplyChannel.Pc}_재신청` : ApplyChannel.Pc;
                    if (idx > 0) requestChannel = `${requestChannel}(형제회원)`;
                    if (idx === 0 && isUnderAgeAndFirst) requestChannel = `${ApplyChannel.Pc}_사전신청`;

                    const contentLevels = service.getTemporaryInformationLevelParams(studentInfo.checkList);

                    return {
                        informationType: 'ExperienceReapplication',
                        parentAuthHumanName: human_name,
                        parentAuthHumanMdn: human_mdn,
                        requestChannel,
                        studentAuthHumanName: studentInfo.auth_detail.human_name,
                        studentIsMale: studentInfo.auth_detail.is_male,
                        studentBirthday: moment(studentInfo.auth_detail.birthday).format('YYYY-MM-DD HH:mm:ss'),
                        studentHumanPostalCode: human_postal_code,
                        studentHumanAddress: human_address,
                        studentHumanDetailAddress: human_detail_address,
                        registeredDate: moment().format('YYYY-MM-DD HH:mm:ss'),
                        ...getTemporaryInformationOptionalAgreementParams(
                            termsAgreementOverride
                        ),
                        ...contentLevels,
                    };
                });

                modifyAuths({
                    data: {
                        terms_agreement: withTermsAgreementContext(
                            {
                                ...getAuthTermAgreement(),
                                ...termsAgreementOverride,
                            },
                            TERMS_AGREEMENT_CONTEXT.PC_FREE_STUDY
                        ),
                    },
                });

                await Promise.all(
                    paramsToApply.map((tempInfo) => {
                        const obj = api.addTemporaryInformationActor(tempInfo);
                        return silentUpdateMultipleList([
                            {
                                id: 'temporaryInformationActor',
                                url: obj.url,
                                params: obj.params,
                            },
                        ]);
                    })
                );
                service.sendLevelChoiceGaEvent(selectedStudentInfoList, levelChoicesRef.current);
                await applySimple();
                completedAction();
                history.replace(routes.wink.freeStudyComplete);
                return;
            }

            if (isChangeUserInfo) {
                if (human_email && human_email !== '@') {
                    // 이메일 있는경우 이미 사용 여부 체크
                    const { data } = await UserServices.emailDuplicateCheck(human_email);
                    if (data.count > 0 && auth.human_email !== human_email) {
                        DesktopLayerPopup.notice({
                            message: EmailDuplicationText,
                        });
                    }
                }
                await modifyAuths({
                    human_address,
                    human_detail_address,
                    human_postal_code,
                    human_email: human_email && human_email !== '@' ? human_email : null,
                    data: {
                        ...auth.data,
                        terms_agreement: withTermsAgreementContext(
                            {
                                ...getAuthTermAgreement(),
                                ...termsAgreementOverride,
                            },
                            TERMS_AGREEMENT_CONTEXT.PC_FREE_STUDY
                        ),
                    },
                });
            } else {
                await modifyAuths({
                    data: {
                        terms_agreement: withTermsAgreementContext(
                            {
                                ...getAuthTermAgreement(),
                                ...termsAgreementOverride,
                            },
                            TERMS_AGREEMENT_CONTEXT.PC_FREE_STUDY
                        ),
                    },
                });
            }

            service.sendLevelChoiceGaEvent(selectedStudentInfoList, levelChoicesRef.current);
            const result = await applyStudy(
                selectedStudentInfoList[0].id,
                service.getMappedCheckList(todayStudyMap, selectedStudentInfoList[0].checkList),
                ApplyChannel.Pc,
                '',
                hasExperiencePreConsultWork,
                ''
            );
            if (result === 'succeeded') {
                completedAction();
                if (selectedStudentInfoList && experienceCount?.[selectedStudentInfoList[0]?.id] >= 3) {
                    DesktopLayerPopup.notice({
                        message:
                            '체험 이력이 있습니다.<br />체험 신청 완료 후 학부모님 공감센터를 통해<br />추가 안내가 진행됩니다.',
                        showXButton: false,
                        callback: () => {
                            history.replace(routes.wink.freeStudyComplete);
                        },
                    });
                    return;
                }
                history.replace(routes.wink.freeStudyComplete);
            }
        } catch (e) {
            console.error(e);
            DesktopLayerPopup.notice({ message: '오류가 발생하였습니다. 잠시 후 다시 시도해주세요.' });
        } finally {
            setSpin(false);
        }
    };

    const onClickConfirm = (e) => {
        e.preventDefault();
        if (!isFieldsValid()) return false;
        validateAndShowAgreementPopup(applyFreeStudy);
    };

    const onCloseRegistChild = ({ type, payload } = {}, studentInfo) => {
        if (type === values.REGIST_CHILD_ANSWER_TYPE.IS_ONE_MORE_REQUEST) {
            const newOneMoreNames = [...oneMoreNames, payload.name];
            setState((prev) => ({
                ...prev,
                oneMoreNames: newOneMoreNames,
            }));

            const availableStudents = getAvailableApplyStudents(newOneMoreNames);
            const childIndex = availableStudents.findIndex(({ auth_human_name }) => auth_human_name === payload.name);
            checkChildSubjectWithName(childIndex, studentInfo, newOneMoreNames);
        }
    };

    const addStudentInfo = () => {
        const currentLevel = service.getCurrentLevels();
        studentSeqRef.current += 1;
        const newStudentInfoList = [
            ...(selectedStudentInfoList ?? []),
            { key: studentSeqRef.current, checkList: currentLevel },
        ];

        setSelectedStudentInfoList(newStudentInfoList);
    };

    const removeStudentInfo = (keyToRemove) => {
        setSelectedStudentInfoList(selectedStudentInfoList?.filter(({ key }) => key !== keyToRemove));
    };

    const getAvailableApplyStudents = (oneMoreNamesArg = []) => {
        if (studentList && studentList.length !== 0) {
            const availableStudents = studentList.filter((student) => ParentsUtil.canExperience(student));
            const oneMoreStudents = studentList.filter((student) => oneMoreNamesArg.includes(student.auth_human_name));
            if (oneMoreStudents && oneMoreStudents.length > 0) {
                for (let oneMoreStudent of oneMoreStudents) {
                    const isExist = availableStudents.some(
                        ({ auth_human_name }) => auth_human_name === oneMoreStudent.auth_human_name
                    );
                    if (!isExist) availableStudents.push(oneMoreStudent);
                }
            }
            return availableStudents;
        }
        return [];
    };

    return (
        <div id="contents" className="wink-free-study">
            <TrialApplyDescription />
            <div id={'request-study-form-id'}>
                <WinkFreeStudyShippingAddress userInfo={userInfo} setUserInfo={setUserInfo} auth={auth} />
                {selectedStudentInfoList?.map((studentInfo, idx, originalArr) => (
                    <div key={studentInfo.key}>
                        <WinkFreeStudyChildSelect
                            studentKey={studentInfo.key}
                            checkChildSubject={(index) => checkChildSubject(index, studentInfo)}
                            childIndex={studentInfo.childIndex}
                            availableStudents={getAvailableApplyStudents(oneMoreNames)}
                            onClose={(type) => onCloseRegistChild(type, studentInfo)}
                        />
                        {selectedStudentInfoList[idx]?.id && (
                            <section>
                                <LevelSelection
                                    studentInfo={studentInfo}
                                    onChangeStudentInfo={(newStudentInfo) => {
                                        setSelectedStudentInfoList(
                                            selectedStudentInfoList.map((studentInfo, index) => {
                                                if (index === idx) {
                                                    return {
                                                        ...studentInfo,
                                                        ...newStudentInfo,
                                                    };
                                                }
                                                return studentInfo;
                                            })
                                        );
                                    }}
                                    setLevelChoicesForGA={({ levelChoice, manuallyLevelChoice }) => {
                                        levelChoicesRef.current[idx] = { levelChoice, manuallyLevelChoice };
                                    }}
                                />
                                <AddtionalStudent
                                    studentInfoList={selectedStudentInfoList}
                                    idx={idx}
                                    removeStudentInfo={removeStudentInfo}
                                    addStudentInfo={addStudentInfo}
                                    originalArr={originalArr}
                                />
                            </section>
                        )}
                    </div>
                ))}
            </div>
            <AgreementSection agreement={termsAgreement} onCheckBox={onAgreementCheckBox} />
            <div className="new-btn-area bottom">
                <a className="new-btn btn-confirm" onClick={onClickConfirm}>
                    신청 완료
                </a>
            </div>
        </div>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(WinkFreeStudy);
